import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon-leanpath-logo.png'


const _hoisted_1 = ["data-color"]
const _hoisted_2 = { class: "sidebar-container__main" }
const _hoisted_3 = { class: "sidebar-container__content sidebar-content" }
const _hoisted_4 = {
  key: 1,
  class: "sidebar-content__expanded-item"
}
const _hoisted_5 = { class: "sidebar-container__toggle-item toggle-item" }

import { computed, nextTick, onMounted, provide, reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { RouterItem } from './interfaces/routerItems';
import { ROUTER_ITEMS_FOR_DEVELOPMENT, ROUTER_ITEMS_FOR_PRODUCTION } from './constants';
import SideBarItem from './SideBarItem.vue';
import SideBarExpandedItem from './SideBarExpandedItem.vue';
import { DropDownMenuItem } from './interfaces/dropDownItem';
import { useStore } from 'vuex';
import ChangePassword from '@/pages/login/ChangePassword.vue';
import { logout } from '@/awsCodes/awsUtils';
import ProfileMenu from './ProfileMenu.vue';
import { clearBusinessDataInServer, clearOrganizationTable } from '@/appLogic/initializers/organizationTable';
import { clearPreferenceDataInServer, clearPreferenceTable } from '@/appLogic/initializers/preferenceTable';
import { clearSharingDataInServer, clearSharingTable } from '@/appLogic/initializers/sharingTable';
import { allReminderDelete } from '@/businessRepository/reminderTable/dataAccess';
import { getUserId } from '@/awsCodes/awsUtils';
import SvgLoader from '@/utils/SvgLoader.vue';
import ChangeLanguage from '@/corePagesModule/components/i18n/ChangeLanguage.vue';
import { DeleteAllBusinessForDebugMenuUseCase } from '@/coreUseCasesModule/debugBusinessMenu/deleteAllBusinessForDebugMenuUseCase';
import { DeleteBusinessRepository } from '@/coreInfrastructureModule/Repositories/DeleteBusinessRepository';
import { openConfirmModal, openLoadingModal, openOkInformationModal } from '@/corePagesModule/components/modal/modalActions';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { i18n } from '@/i18n';
import SideBarItemWithSubMenu from './SideBarItemWithSubMenu.vue';
import NotificationMenu from './NotificationMenu.vue';
import { NotificationMenuItem } from './interfaces/notificationMenuItem';
import { SqsAccessManageRepository } from '@/coreInfrastructureModule/Repositories/SqsAccessManageRepository';
import { PostSqsMessageUseCase } from '@/coreUseCasesModule/sqsAccessManage/postSqsMessage';
import { GetSqsMessageUseCase } from '@/coreUseCasesModule/sqsAccessManage/getSqsMessage';
import { DeleteSqsStatusInfoFromDynamoDbUseCase } from '@/coreUseCasesModule/sqsAccessManage/deleteSqsStatusInfoFromDynamoDbResponseInfo';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { removeAllFilterInfos } from '@/appLogic/view/preferences';
import { diContainer } from '@/coreContainer/container';

export default /*@__PURE__*/_defineComponent({
  __name: 'SideBar',
  props: {
  title: {
    type: String,
    default: 'LEAN PATH',
  },
  sidebarItemColor: {
    type: String,
    default: 'green',
    validator: (value: string): boolean => {
      const acceptedValues = ['main', 'purple', 'blue', 'green', 'orange', 'red'];
      return acceptedValues.indexOf(value) !== -1;
    },
  },
  sidebarLinks: {
    type: Array,
    default: () => [],
  },
  autoClose: {
    type: Boolean,
    default: true,
  },
},
  emits: ["toggleHideMode"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const t = i18n.t;

const deleteBusinessRepository = new DeleteBusinessRepository();
const deleteAllBusinessForDebugMenuUseCase = new DeleteAllBusinessForDebugMenuUseCase();
const sqsAccessManageRepository = new SqsAccessManageRepository();

const props = __props;

const emits = __emit;

// リアクティブ変数
const state = reactive<{
  userId: string;
  hideMode: boolean;
  expandedIndex: number;
  modalState: boolean;
  notificationItems: NotificationMenuItem[];
  unmatchedOrderCount?: string;
}>({
  userId: '',
  hideMode: true,
  expandedIndex: -1,
  modalState: false,
  notificationItems: [],
  unmatchedOrderCount: undefined,
});

onMounted(() => {
  state.userId = getUserId();
  fetchNotificationItems();
  fetchUnmatchedOrderCount();
});

// 計算プロパティ
const dev = computed(() => process.env.NODE_ENV === 'development');
const production = computed(() => process.env.NODE_ENV === 'production');

const routerItems = computed((): RouterItem[] => {
  // デプロイ時の表示制限用
  const items = production.value ? [...ROUTER_ITEMS_FOR_PRODUCTION] : [...ROUTER_ITEMS_FOR_DEVELOPMENT];
  return items.map((item) => {
    if (item.to === '/firm-order') {
      return { ...item, badge: state.unmatchedOrderCount };
    }
    return item;
  });
});

const computedSideBarLinksClass = computed(() => ({
  'sidebar-content__links--hide': state.hideMode,
  'sidebar-content__links--expand': !state.hideMode,
}));

watch(
  () => route.fullPath,
  () => {
    console.log('route changed');
    fetchNotificationItems();
    fetchUnmatchedOrderCount();
  }
);

/**
 * ドロップダウンに展開する項目名と機能をまとめた配列 (ドロップダウンに持たせるアイテム群)
 */
const profileMenuItems = computed((): DropDownMenuItem[] => {
  // デプロイ時の表示制限用;
  if (process.env.NODE_ENV === 'production') {
    return [
      {
        label: 'パスワード変更',
        icon: 'key',
        action: openChangePasswordModal,
      },
      {
        label: 'ログアウト',
        icon: 'logout',
        action: doLogout,
      },
      {
        label: 'サーバ(RDS)全取引削除（開発用）',
        action: dispatchDidDeleteAllBusinessFromRDS,
      },
      {
        label: 'preferenceTbl削除 (開発用)',
        action: deletePreference,
      },
    ];
  }
  return [
    {
      label: 'パスワード変更',
      icon: 'key',
      action: openChangePasswordModal,
    },
    {
      label: 'ログアウト',
      icon: 'logout',
      action: doLogout,
    },
    {
      label: 'サーバ(RDS)全取引削除（開発用）',
      action: dispatchDidDeleteAllBusinessFromRDS,
    },
    {
      label: 'SQSサンプルメッセージ送信',
      action: postSqsMessage,
    },
    {
      label: 'サーバ(RDS)全取引削除 & 初期データ挿入（開発用）',
      action: dispatchDidDeleteAllBusinessFromRDSWithInitialData,
    },
    {
      label: 'preferenceTbl削除 (開発用)',
      action: deletePreference,
    },
    {
      label: '全データ削除（開発用）',
      action: allDelete,
    },
    {
      label: 'サーバデータ削除（開発用）',
      action: allDeleteServerData,
    },
    {
      label: '全データ削除&サンプル作成',
      action: allDeleteAndGenerateSampleData,
    },
    {
      label: '全リマインド情報削除',
      action: deleteReminder,
    },
  ];
});

/**
 * 未照合・差異一覧のpending件数を取得する
 * なお、99件以上は 99+ にする
 */
const fetchUnmatchedOrderCount = async () => {
  try {
    const result = await diContainer.getUnmatchedOrdersUseCase.execute(99, 0);
    if (result.status.type === 'success') {
      const returnCount = result.status.data[0].returnCount;
      const suffix = result.status.data[0].totalResultsAvailable !== result.status.data[0].returnCount ? '+' : '';
      state.unmatchedOrderCount = returnCount === 0 ? undefined : `${returnCount.toString()}${suffix}`;
    }
  } catch {
    // サイドバーのバッジ表示はベストエフォートなのでエラーは無視
  }
};

/**
 * SQSをトリガーとする処理の通知情報を取得する
 */
const fetchNotificationItems = async () => {
  // 通知情報の取得処理
  try {
    const result = await GetSqsMessageUseCase.execute(sqsAccessManageRepository);

    // 結果に基づいてモーダルを表示
    switch (result.status.type) {
      case 'success':
        console.log('=== Gat Notification Items ===');
        state.notificationItems = [];
        for (const item of result.status.data) {
          state.notificationItems.push({
            requestId: item.requestId,
            status: item.status,
            actionName: 'sample',
          });
        }
        break;
      case 'error':
        console.error('=== Get Notification Items Error ===');
        break;
    }
  } catch (error) {
    console.error('=== エラーが発生しました ===', error);
  }
  // state.notificationItems = await fetchNotificationItemsUseCase.Execute();
};

/**
 * 通知情報の削除を行う
 * @param requestId - 通知情報のID
 */
const deleteNotificationItem = async (requestId: string) => {
  // 通知情報の削除処理
  try {
    const result = await DeleteSqsStatusInfoFromDynamoDbUseCase.execute(sqsAccessManageRepository, requestId);

    // 結果に基づいてモーダルを表示
    switch (result.status.type) {
      case 'success':
        console.log('=== Gat Notification Items ===');
        console.log({ リザルト: result.status.data });
        break;
      case 'error':
        console.error('=== Get Notification Items Error ===');
        break;
    }
  } catch (error) {
    console.error('=== エラーが発生しました ===', error);
  }
};

/**
 * サイドバー開閉のアイコン名
 */
const computedToggleIconName = computed(() => (state.hideMode ? 'arrowForward' : 'arrowBack'));

// サイドバー開閉管理
const toggleHideMode = function () {
  state.hideMode = !state.hideMode;
  emits('toggleHideMode');
};

/**
 * パスワード変更モーダルを表示する
 */
const openChangePasswordModal = () => {
  state.modalState = true;
};

const doLogout = async () => {
  // IndexedDB内のフィルター情報は機密情報が入っているためログアウト時に削除
  await removeAllFilterInfos();
  await logout();
  store.commit('loginStateModule/setUnAuthenticated');
  await nextTick();
  await router.push('/login');
};

const postSqsMessage = async () => {
  try {
    // ローディングモーダルを表示し、非同期関数を実行
    const result = await openLoadingModal('Loading...', PostSqsMessageUseCase.execute, [sqsAccessManageRepository]);

    // 結果に基づいてモーダルを表示
    switch (result.status.type) {
      case 'success':
        console.log('=== Business Deleted ===');
        await openOkInformationModal('success', t('完了した'), 'OK', t('登録されました'));
        break;
      case 'error':
        console.error('=== 取引削除において、想定外のエラーが発生しました ===');
        await openOkInformationModal('error', t('エラー'), 'OK', t('登録に失敗しました'));
        break;
    }
  } catch (error) {
    console.error('=== エラーが発生しました ===', error);
    await openOkInformationModal('error', t('エラー'), 'OK', t('処理中にエラーが発生しました'));
  }
};

/**
 * indexDBからのデータ削除処理
 */
const allDelete = async () => {
  await clearOrganizationTable();
  await clearSharingTable();
  //await clearPreferenceTable(); // TODO: 完成したらアンコメント
  location.reload();
};

/**
 * サーバーに登録されているデータの削除処理
 */
const allDeleteServerData = async () => {
  await clearBusinessDataInServer();
  await clearSharingDataInServer(); // TODO: 完成したらアンコメント
  await clearPreferenceDataInServer();
  location.reload();
};

/**
 * indexDB、サーバーに登録されているデータを共に削除し、サンプルデータを登録する処理
 */
const allDeleteAndGenerateSampleData = async () => {
  // indexDBからの削除
  await clearOrganizationTable();
  await clearSharingTable();
  //await clearPreferenceTable(); // TODO: 完成したらアンコメント

  // サーバーからの削除
  await clearBusinessDataInServer();
  await clearSharingDataInServer(); // TODO: 完成したらアンコメント
  await clearPreferenceDataInServer();

  // サンプルデータ作成
  // if (!(await registerSampleImportExcelData())) {
  //   // 取り込むサンプルデータの種類を切り替える場合は以下を使用する
  //   // if (!(await registerSampleData())){
  //   console.log('サンプルデータの登録に失敗しました');
  // }
  location.reload();
};

/**
 * リマインド情報の削除
 */
const deleteReminder = async () => {
  await allReminderDelete();
};

/**
 * RDSに登録されている取引情報の削除を行う
 * 初期データを挿入する
 */
const dispatchDidDeleteAllBusinessFromRDSWithInitialData = async () => {
  await didDeleteAllBusinessFromRDS(true);
};

/**
 * RDSに登録されている取引情報の削除を行う
 * 初期データを挿入しない
 */
const dispatchDidDeleteAllBusinessFromRDS = async () => {
  await didDeleteAllBusinessFromRDS(false);
};

/**
 * RDSに登録されている取引情報の削除を行う
 * 削除対象は自身が所属している組織IDを持っている取引情報
 * @param useInitialData - 初期データを挿入するかどうか
 */
const didDeleteAllBusinessFromRDS = async (useInitialData: boolean) => {
  // 確認モーダルを表示
  const modalResult = await openConfirmModal('question', t('登録済みの取引情報を全て削除しますか？'), t('はい'), t('いいえ'));

  // モーダルの結果を確認
  if (modalResult === undefined || modalResult.isConfirmed === false) {
    return;
  }

  try {
    // ローディングモーダルを表示し、非同期関数を実行
    const result = await openLoadingModal('Loading...', deleteAllBusinessFromRDS, [useInitialData]);

    // 結果に基づいてモーダルを表示
    switch (result.status.type) {
      case 'success':
        console.log('=== Business Deleted ===');
        await openOkInformationModal('success', t('完了した'), 'OK', t('削除されました'));
        break;
      case 'error':
        console.error('=== 取引削除において、想定外のエラーが発生しました ===');
        await openOkInformationModal('error', t('エラー'), 'OK', t('削除に失敗しました'));
        break;
    }
  } catch (error) {
    console.error('=== エラーが発生しました ===', error);
    await openOkInformationModal('error', t('エラー'), 'OK', t('処理中にエラーが発生しました'));
  }
};

/**
 * 取引削除APIを実行する処理
 * @param useInitialData - 初期データを挿入するかどうか
 */
const deleteAllBusinessFromRDS = async (useInitialData: boolean): Promise<INetworkResult<object, Error>> => {
  const result = await deleteAllBusinessForDebugMenuUseCase.Execute(deleteBusinessRepository, useInitialData);
  return result;
};

/**
 * preferenceTbl削除
 */
const deletePreference = async () => {
  await clearPreferenceTable();
  // await clearPreferenceDataInServer(); // NOTE: AWS側のPreferenceTableも削除する
  location.reload();
};

/**
 * 折り畳みされているサイドバーのアイテムの開閉
 * @param index - インデックス
 */
const onClickExpandChildren = (index: number) => {
  if (state.expandedIndex === index) {
    state.expandedIndex = -1;
  } else {
    state.expandedIndex = index;
  }
};

/**
 * サイドバーのアイテムをアクティブにするかどうか
 * @param routeItem - サイドバーアイコンのルート情報
 */
const activeSidebarItem = function (routeItem: RouterItem): boolean {
  // 現在のルートのネスト内に対象のパスが含まれていればアクティブ
  const isActive = route.matched.map((route) => route.path).includes(routeItem.to);
  if (!isActive && routeItem.expandChildren)
    return routeItem.expandChildren.some((child) => route.matched.map((route) => route.path).includes(child.to));
  return isActive;
};

// プロバイダー
provide('autoClose', props.autoClose);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "sidebar-container",
    "data-color": __props.sidebarItemColor
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "sidebar-content__logo" }, [
          _createElementVNode("a", { href: "/registration" }, [
            _createElementVNode("div", { class: "logo-img" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Lean Path"
              })
            ])
          ])
        ], -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["sidebar-content__links", computedSideBarLinksClass.value])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routerItems.value, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (state.hideMode)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (item.expandChildren)
                      ? (_openBlock(), _createBlock(SideBarItemWithSubMenu, {
                          key: 0,
                          "side-bar-index": index,
                          class: _normalizeClass({ 'sidebar-content--active': activeSidebarItem(item) }),
                          "route-item": item
                        }, null, 8, ["side-bar-index", "class", "route-item"]))
                      : (_openBlock(), _createBlock(SideBarItem, {
                          key: 1,
                          class: _normalizeClass({ 'sidebar-content--active': activeSidebarItem(item) }),
                          "route-item": item
                        }, null, 8, ["class", "route-item"]))
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(SideBarExpandedItem, {
                      class: _normalizeClass({ 'sidebar-content--active': activeSidebarItem(item) && state.expandedIndex !== index }),
                      "route-item": item,
                      "is-root": true,
                      "is-open-children": state.expandedIndex === index,
                      onOnClickExpansionToggle: ($event: any) => (onClickExpandChildren(index))
                    }, null, 8, ["class", "route-item", "is-open-children", "onOnClickExpansionToggle"]),
                    (state.expandedIndex === index)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.expandChildren, (child) => {
                          return (_openBlock(), _createBlock(SideBarExpandedItem, {
                            key: child.name,
                            class: _normalizeClass({ 'sidebar-content--active': activeSidebarItem(child) }),
                            "route-item": child,
                            "is-root": false
                          }, null, 8, ["class", "route-item"]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ]))
            ], 64))
          }), 128))
        ], 2),
        _createVNode(ChangeLanguage),
        _createVNode(ProfileMenu, {
          "menu-items": profileMenuItems.value,
          "user-name": state.userId
        }, null, 8, ["menu-items", "user-name"]),
        (dev.value)
          ? (_openBlock(), _createBlock(NotificationMenu, {
              key: 0,
              "notification-items": state.notificationItems,
              onDeleteTargetRequestId: _cache[0] || (_cache[0] = ($event: any) => (deleteNotificationItem($event)))
            }, null, 8, ["notification-items"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "toggle-item__icon",
          onClick: toggleHideMode
        }, [
          _createVNode(SvgLoader, { name: computedToggleIconName.value }, null, 8, ["name"])
        ])
      ])
    ]),
    _createVNode(InfoModal, {
      "modal-state": state.modalState,
      "enable-outside-click": false
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('パスワードの変更')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(ChangePassword, {
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (state.modalState = false))
        })
      ], undefined, true),
      _: 1
    }, 8, ["modal-state"])
  ], 8, _hoisted_1))
}
}

})